import { Link } from "react-router-dom";

const PageHero = ({ kicker, title, intro, breadcrumb }) => (
  <section data-testid="page-hero" className="border-b border-slate-200 bg-gold-soft/60 py-14 sm:py-20">
    <div className="container-site max-w-4xl">
      {breadcrumb && (
        <nav aria-label="Percorso" className="mb-5 text-xs uppercase tracking-[0.18em] text-slate-500">
          <Link to="/" data-testid="breadcrumb-home" className="transition-colors hover:text-gold-dark">Home</Link>
          <span className="mx-2" aria-hidden="true">/</span>
          <span className="text-gold-dark">{breadcrumb}</span>
        </nav>
      )}
      {kicker && <p className="kicker">{kicker}</p>}
      <h1 className="mt-3 font-serif text-4xl sm:text-5xl font-bold tracking-tight text-navy">
        {title}
      </h1>
      {intro && (
        <p className="mt-5 text-base sm:text-lg leading-relaxed text-slate-600">{intro}</p>
      )}
    </div>
  </section>
);

export default PageHero;
